/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.reminders

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.stringResource
import studio.oddpods.cauce.feature.reminders.generated.resources.Res
import studio.oddpods.cauce.feature.reminders.generated.resources.feature_reminders_confirm_cancel
import studio.oddpods.cauce.feature.reminders.generated.resources.feature_reminders_confirm_open
import studio.oddpods.cauce.feature.reminders.generated.resources.feature_reminders_confirm_title

@Composable
fun ConfirmReminderDialog(
    dialog: ConfirmDialogData,
    isSending: Boolean,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(stringResource(Res.string.feature_reminders_confirm_title)) },
        text = {
            Column(
                modifier = androidx.compose.ui.Modifier.verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                Text("${dialog.patientName} · ${dialog.patientPhone}")
                Text(dialog.messageText)
            }
        },
        confirmButton = {
            TextButton(onClick = onConfirm, enabled = !isSending) {
                Text(stringResource(Res.string.feature_reminders_confirm_open))
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss, enabled = !isSending) {
                Text(stringResource(Res.string.feature_reminders_confirm_cancel))
            }
        },
    )
}
